<template>
    <div class="page-block__item-wrapper">
        <h3>{{ trans('hosting.settings-title') }}</h3>

        <server-information v-if="subscription.server_name" :serverName="subscription.server_name" />

        <hosting-ssh v-if="!customerConfigLoading && isDirectAdmin(subscription)" :domain="domain" :customerConfig="customerConfig" />

        <hosting-ssl v-if="!customerConfigLoading && isDirectAdmin(subscription)" :domain="domain" :customerConfig="customerConfig" />

        <hosting-dns v-if="!customerConfigLoading && isDirectAdmin(subscription)" :domain="domain" :customerConfig="customerConfig" />

        <div class="page-block__item">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/3-desk">
                        <span class="page-block__item-content-title">
                            {{ trans('hosting.settings.manage') }}
                        </span>
                    </div>
                    <!-- Gives extra space! Do not delete.
                 -->
                    <div class="layout__item u-2/3-desk">
                        {{ trans('hosting.settings.manage-info') }}
                    </div>
                </div>
            </div>
            <div class="page-block__item-nav">
                <button @click="showSsoModal" type="button" class="btn btn--ghost btn--ghost-full-width">
                    {{ trans('hosting.settings.manage-button') }}
                </button>
            </div>
        </div>

        <sso-modal v-if="ssoModalVisible" @close="closeSsoModal" :domain="domain" />
    </div>
</template>

<script>
import SsoModal from './SsoModal.vue';
import HostingSsh from './HostingSsh.vue';
import HostingSsl from './HostingSsl.vue';
import HostingDns from './HostingDns.vue';
import { ServerInformation } from 'relapp-technical-management';
import HostingApi from '../services/api/hosting.js';
import {EventBus} from "relapp-event/src/event";

export default {
    components: {
        HostingSsh,
        HostingSsl,
        HostingDns,
        SsoModal,
        ServerInformation,
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            customerConfig: {},
            customerConfigLoading: true,
            ssoModalVisible: false,
            password: '---'
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        if (this.isDirectAdmin(this.subscription)) {
            this.getCustomerConfig();
        }
    },
    methods: {
        /**
         * Load hosting package customer config.
         */
        getCustomerConfig() {
            HostingApi.customerConfig(this.domain)
                .then(response => {
                    this.customerConfig = response.data;
                    this.customerConfigLoading = false;
                })
                .catch(function (result) {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: result.data.message
                    });
                });
        },

        /**
         * Show the modal to login to Plesk.
         */
        showSsoModal() {
            this.ssoModalVisible = true;
        },

        /**
         * Close the modal.
         */
        closeSsoModal() {
            this.ssoModalVisible = false;
        },

        /**
         * Used to decide if we want to display the SSH/SSL/DNS button.
         */
        isDirectAdmin(subscription) {
            return subscription.hosting_provider === "directadmin";
        }
    }
};
</script>
